import React, {useState} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { AnimatePresence } from 'framer-motion';

import { ListTile, Button, Animation } from 'components';
import CustomAlert from './CustomAlert';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const timeOptions = [
    // {value: 'At time of event', metric: null},
    {value: 10, metric: 'minutes'},
    {value: 1, metric: 'hours'},
    {value: 1, metric: 'days'},
    {value: 'Custom', metric: null}
]

const dateOptions = [
    // {value: 'At time of event', metric: null},
    {value: 1, metric: 'days'},
    {value: 2, metric: 'days'},
    {value: 1, metric: 'weeks'},
    {value: 'Custom', metric: null}
]

const AlertOptions = props => {
    const {
        onSelect,
        type,
    } = props;
    const [custom, setCustom] = useState(false)

    const onCustomAlert = alert => {
        console.log('onCustomAlert', alert)
        onSelect(alert)
    }

    const _getOptions = () => {
        let blocks = []

        // Main blocks
        Object.values(type === 'time' ? timeOptions : dateOptions).map(alert => {
            const value = alert.value
            const metric = alert.value === 1 ? alert.metric.replace('s','') : alert.metric
            blocks.push(<ListTile key={uuidv4()}text={alert.metric ? `${value} ${metric} before` : value}  
                onSelect={alert.value === 'Custom' ? () => setCustom(!custom)
                :() => onSelect && onSelect(alert)}/>)
        })
        return blocks
    }
    const blocks = _getOptions()
    return(
        <Container>
            {blocks}
            <AnimatePresence>
                {custom && <Animation animation='expand'><CustomAlert type={type} onSubmit={onCustomAlert}/></Animation>}
            </AnimatePresence>
        </Container>
    )
}

export default AlertOptions

AlertOptions.propTypes = {
    type: PropTypes.oneOf(['day', 'time']),
    onSelect: PropTypes.func,
}